import React, { useEffect, useReducer, useState, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link, useParams, useNavigate } from 'react-router-dom'
import { subscribe } from "../utils/pubsub"
import Button from '../formfields/Button'
import RedAlert from '../ui-elements/RedAlert'
import EnabledDisabled from '../formfields/EnabledDisabled'
import Number from '../formfields/Number'
import Card from '../ui-elements/Card'
import FooterNavButtonFrame from '../ui-elements/FooterNavButtonFrame'
import ListEmailAddresses from './ListEmailAddresses'
import HtmlEditor from '../formfields/HtmlEditor'


type Props = {
}

function AutomaticReportsForm({
}: Props) {



  const {
    tableData,
    userData,
    fridges,
    currentOrganisation,
    switchCurrentOrganisation,
    sendMessageToWebsocket,
    checklistSetupFields,
    setChecklistSetupFields,
    checklistQuestionFields,
    setChecklistQuestionFields,
    activeFeatures,
    expiredFeatures,
    loggedIn,
    loginUrl,
    setShowModal,
    currentPortalId
  } = useContext(GlobalContext)


  const navigate = useNavigate()
  const { Id } = useParams()
  const [formFields, setFormFields] = useState<ObjectStringKeyAnyValue>({})
  const [formErrors, setFormErrors] = useState<ObjectStringKeyAnyValue>({})
  const [documentLibraries, setDocumentLibraries] = useState<ObjectStringKeyAnyValue>([])
  const [showUploadButton, setShowUploadButton] = useState<boolean>(false)

  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
  const reportMetric = formFields && formFields['reportMetric'] ? formFields['reportMetric'] : null
  const reportingFrequency = formFields && formFields['Frequency'] ? formFields['Frequency'] : null
  const reportDurationPeriod = formFields && formFields['reportDurationPeriod'] ? formFields['reportDurationPeriod'] : null
  const organisationsToInclude = formFields && formFields['OrganisationsToInclude'] ? formFields['OrganisationsToInclude'] : null
  const sendReportToOneDrive = formFields && formFields['sendReportToOneDrive'] ? formFields['sendReportToOneDrive'] : null
  const preferredFileFormat = formFields && formFields['preferredFileFormat'] ? formFields['preferredFileFormat'] : null
  const templateOption = formFields && formFields['templateOption'] ? formFields['templateOption'] : ''
  const templateCellReference = formFields && formFields['templateCellReference'] ? formFields['templateCellReference'] : ''
  const [fileToUpload, setFileToUpload] = useState<any>(null)




  useEffect(() => {
    if (Id && tableData && currentPortalId && tableData.Portals && tableData.Portals[currentPortalId] && tableData.Portals[currentPortalId].AutomaticReports && tableData.Portals[currentPortalId].AutomaticReports[Id]) {
      // if an Id is provided, load the existing report data
      setFormFields(tableData.Portals[currentPortalId].AutomaticReports[Id])
    }
  }, [Id, tableData])


  // try to get a list of valid onedrive document libraries for the current organisation
  // by sending onedrive getPlacesToSaveReports to the websocket
  useEffect(() => {
    if (currentOrganisation) {
      const payload = JSON.stringify({
        "action": "onedrive",
        "subAction": "getPlacesToSaveReports"
      })
      const unsubscribe = subscribe("OnedrivePlacesToSaveReports", data => {
        if (data && data.documentLibraries) {
          setDocumentLibraries(data.documentLibraries)
          unsubscribe()
        }
      })
      sendMessageToWebsocket(payload)

    }
  }, [])

  const handleChange = (key: string, value: any) => {
    console.log('handleChange', key, value)
    const newFieldValues: ObjectStringKeyAnyValue = { ...formFields }
    newFieldValues[key] = value
    setFormFields(newFieldValues)
  }



  const handleChangeTemplateOption = (key: string, value: any) => {
    console.log('handleChange', key, value)
    const newFieldValues: ObjectStringKeyAnyValue = { ...formFields }
    newFieldValues[key] = value
    if (key === 'templateOption' && value !== 'custom') {
      delete newFieldValues['templateFileName']
      delete newFieldValues['templateCellReference']
    }
    setFormFields(newFieldValues)
  }

  const handleAddOrganisationToInclude = (fieldName: any, enabled: boolean) => {
    const newFieldValues: ObjectStringKeyAnyValue = { ...formFields }
    let organisationsList: string[] = []
    if (newFieldValues['OrganisationsToInclude']) {
      organisationsList = [...newFieldValues['OrganisationsToInclude']]
    }
    if (enabled) {
      // add organisation
      organisationsList.push(fieldName)
    }
    else {
      // remove organisation
      organisationsList = organisationsList.filter(orgId => orgId !== fieldName)
    }
    newFieldValues['OrganisationsToInclude'] = organisationsList
    setFormFields(newFieldValues)
  }

  const handleChangeDocumentLibrary = (value: any) => {
    const newFieldValues: ObjectStringKeyAnyValue = { ...formFields }
    if (!newFieldValues['sendReportToOneDrive']) {
      newFieldValues['sendReportToOneDrive'] = {}
    }
    // value is in the format T=tenantId&D=driveId
    // split it to get tenantId and driveId

    if (value) {
      const tenantId = value.split('&')[0].split('=')[1]
      const driveId = value.split('&')[1].split('=')[1]
      console.log('tenantId:', tenantId, 'driveId:', driveId)
      newFieldValues['sendReportToOneDrive']['tenantId'] = tenantId
      newFieldValues['sendReportToOneDrive']['driveId'] = driveId
    }
    else {
      delete newFieldValues['sendReportToOneDrive']['tenantId']
      delete newFieldValues['sendReportToOneDrive']['driveId']
    }
    setFormFields(newFieldValues)
  }


  const handleChangeFrequency = (value: any) => {
    if (reportDurationPeriod !== value) {
      let newFieldValues: ObjectStringKeyAnyValue = { ...formFields, 'Frequency': value }
      if (value === 'monthly') {
        delete newFieldValues['dayOfWeek']
      }
      setFormFields(newFieldValues)
    }
  }



  const handleChangeExportLocation = (fieldName: any, enabled: boolean) => {
    const newFieldValues: ObjectStringKeyAnyValue = { ...formFields }
    if (enabled === false) {
      delete newFieldValues[fieldName]
      if (fieldName === 'sendReportToEmail') {
        delete newFieldValues['EmailRecipients']
        delete newFieldValues['notifyIfNoResults']
      }
    }
    else {
      newFieldValues[fieldName] = {}
    }
    setFormFields(newFieldValues)
  }

  const validateForm = () => {
    let isValid = true
    const newFormErrors: ObjectStringKeyAnyValue = {}

    // check some checklists have been included
    if (!formFields['OrganisationsToInclude'] || formFields['OrganisationsToInclude'].length === 0) {
      isValid = false
      newFormErrors['OrganisationsToInclude'] = 'Please select at least one organisation to include in the report.'
    }


    // if check a valid duration is set
    const max_number = 10
    if (
      !formFields['reportDurationNumber'] ||
      !formFields['reportDurationPeriod'] ||
      (formFields['reportDurationPeriod'] !== 'weeks' && formFields['reportDurationPeriod'] !== 'months') ||
      parseInt(`${formFields['reportDurationNumber']}`) <= 0 ||
      parseInt(`${formFields['reportDurationNumber']}`) > max_number
    ) {
      isValid = false
      newFormErrors['reportDuration'] = 'Please enter a valid report duration.'
    }

    // check a frequency has been selected
    if (!formFields['Frequency']) {
      isValid = false
      newFormErrors['Frequency'] = 'Please select a reporting frequency.'
    }

    // check a report metric has been selected
    if (!formFields['reportMetric']) {
      isValid = false
      newFormErrors['reportMetric'] = 'Please select a reporting metric.'
    }

    // if frequency is weekly, check for a day of week
    if (formFields['Frequency'] === 'weekly' && !formFields['dayOfWeek']) {
      isValid = false
      newFormErrors['Frequency'] = 'Please select a day of the week.'
    }

    // check that at least one export location has been selected
    // if (!formFields['sendReportToEmail'] && !formFields['sendReportToOneDrive']) {
    //   isValid = false
    //   newFormErrors['ExportLocation'] = 'Please select at least one export location (email or OneDrive).'
    // }

    // if sendReportToOneDrive is enabled, check that a document library has been selected
    // if (formFields['sendReportToOneDrive'] && (!formFields['sendReportToOneDrive']['tenantId'] || !formFields['sendReportToOneDrive']['driveId'])) {
    //   isValid = false
    //   newFormErrors['ExportLocation'] = 'Please select a document library to save the report to.'
    // }

    // if sendReportToEmail is enabled, check that at least one user has been selected
    // if (formFields['sendReportToEmail'] && (!formFields['EmailRecipients'] || formFields['EmailRecipients'].length === 0)) {
    //   isValid = false
    //   newFormErrors['ExportLocation'] = 'Please select at least one user to send the report to.'
    // }

    // check that at least one user has been selected
    if ((!formFields['EmailRecipients'] || formFields['EmailRecipients'].length === 0)) {
      isValid = false
      newFormErrors['ExportLocation'] = 'Please select at least one user to send the report to.'
    }

    // if no templateOption is selected
    if (!formFields['templateOption']) {
      isValid = false
      newFormErrors['templateOption'] = 'Please select a template option'
    }

    // if templateOption is 'custom', check a file has been uploaded and a cell reference included
    if (formFields['templateOption'] === 'custom') {
      if (!fileToUpload && !formFields['templateFileName']) {
        isValid = false
        newFormErrors['templateFile'] = 'Please upload a template file.'
      }
      if (!formFields['templateCellReference']) {
        isValid = false
        newFormErrors['templateCellReference'] = 'Please enter a cell reference.'
      }
    }

    if (!formFields['preferredFileFormat']) {
      isValid = false
      newFormErrors['preferredFileFormat'] = 'Please select a preferred file format for the report.'
    }


    setFormErrors(newFormErrors)
    // console.log(newFormErrors)
    return isValid
  }


  const saveData = async () => {
    const isValid = validateForm()
    if (isValid) {
      setShowModal({ "spinner": "Saving..." })
      // generate UUID for the new automatic report
      const reportId = Id || `ar-${crypto.randomUUID()}`
      const reportData = { ...formFields, "Id": reportId }
      const report_payload: ObjectStringKeyAnyValue = {
        "action": "portal",
        "subAction": "saveAutomaticReport",
        "formFields": reportData
      }


      if (fileToUpload) {
        const fileId = await handleFileUpload(reportId, fileToUpload)
        if (fileId) {
          report_payload['formFields']['templateFileName'] = fileId
        } else {
          setShowModal({ "error": "File upload failed. Please try again." })
          return
        }
      }

      sendMessageToWebsocket(JSON.stringify(report_payload))

      const unsubscribe = subscribe("automaticReportSavedResponse", data => {
        if (data && data.Id === reportId) {
          unsubscribe()
          setShowModal(null)
          navigate('/automatic-reports/')
        }
      })
    }
  }


  const handleFileUpload = async (reportId: string, file: File) => {
    //console.log('handle file Upload')
    const fileExtension = file.name.split('.').pop()
    const fileName = `template_${reportId}.${fileExtension}`
    const timestamp = Date.now().toString()
    const payload = JSON.stringify({
      action: "document",
      subAction: "portalReportTemplateUpload",
      fileName: fileName,
      waitingForUploadUrlId: timestamp,
      portalId: `${currentPortalId}`
    })

    const uploadPromise = new Promise<boolean>((resolve) => {
      const unsubscribe = subscribe("fileUploadResponse", async data => {
        //console.log('fileUploadResponse data:', data)
        if (data.signedUrl && data.waitingForUploadUrlId === timestamp) {
          unsubscribe()
          try {
            const response = await fetch(data.signedUrl, {
              method: 'PUT',
              body: file,
              headers: {
                'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              },
            })

            if (response.ok) {
              //console.log('Upload successful')
              resolve(true)
            } else {
              console.error('Upload failed with status:', response.status)
              resolve(false)
            }
          } catch (error) {
            setShowModal({ "error": "File upload failed. Please try again." })
            console.error('Error uploading file:', error)
            resolve(false)
          }
        }
      })
    })

    sendMessageToWebsocket(payload)
    const success = await uploadPromise
    if (success) {
      return fileName
    } else {
      return null
    }
  }





  const testReport = () => {
    const isValid = validateForm()
    if (isValid) {
      setShowModal({ "spinner": "Exporting test report..." })
      // generate UUID for the new automatic report
      const uniqueRequestId = crypto.randomUUID()
      const payload: ObjectStringKeyAnyValue = {
        "action": "portalTasks",
        "formFields": { ...formFields, uniqueRequestId: uniqueRequestId },
        "subAction": "testAutomaticReportEmail"
      }
      sendMessageToWebsocket(JSON.stringify(payload))
      const unsubscribe = subscribe("testAutomaticReportResponse", data => {
        if (data && data.uniqueRequestId === uniqueRequestId) {
          unsubscribe()
          setShowModal(null)
        }
      })
    }
  }



  if (!tableData || !tableData.Organisations || tableData.Organisations.length === 0) {
    return <div className={`w-full flex flex-col items-center`}>
      <div className={`max-w-3xl w-full p-5 flex flex-col gap-5 `}>
        <RedAlert>No organisations found. Please add an organisation first.</RedAlert>
      </div>
    </div>
  }


  return <div className={`w-full flex flex-col items-center`}>
    <div className={`max-w-3xl w-full p-5 flex flex-col gap-5 `}>


      <h2 className={`text-3xl  font-bold font-righteous text-brandblue`}
      >
        Notification Settings
      </h2>


      <Card fullwidth={true}>
        <div className={`w-full flex flex-col gap-2`}>
          <h3 className={`font-righteous text-brandblue text-lg`}>Organisations to include:</h3>
          {Object.keys(tableData.Organisations).map((organisationId: string, index: number) => {
            const organisation = tableData.Organisations[organisationId]
            return <div key={index} className={`flex flex-row gap-2 items-center`}>
              <EnabledDisabled
                handleChange={handleAddOrganisationToInclude}
                enabled={organisationsToInclude && organisationsToInclude.includes(organisationId) ? true : false}
                fieldName={`${organisationId}`}
              />
              <p>{organisation.OrganisationName}</p>
            </div>
          })}
        </div>
        {formErrors['OrganisationsToInclude'] && <RedAlert size='small'>{formErrors['OrganisationsToInclude']}</RedAlert>}
      </Card>


      <Card fullwidth={true}>
        <div className={`flex flex-col gap-2`}>
          <h3 className={`font-righteous text-brandblue text-lg`}>Report metric</h3>

          <div className={`flex flex-row gap-2 items-end`}>
            <Button
              onClick={() => handleChange('reportMetric', 'percentageOfChecklists')}
              text='Percentage of checklists completed'
              variant={reportMetric === 'percentageOfChecklists' ? `primary` : `gray`}
              fullwidth={false}
            />
            <Button
              onClick={() => handleChange('reportMetric', 'numberOfChecklists')}
              text='Number of checklists scheduled'
              variant={reportMetric === 'numberOfChecklists' ? `primary` : `gray`}
              fullwidth={false}
            />
          </div>
        </div>


        {formErrors['reportMetric'] && <RedAlert size='small'>{formErrors['reportMetric']}</RedAlert>}
      </Card>




      {organisationsToInclude && <Card fullwidth={true}>
        <div className={`flex flex-col gap-2`}>
          <h3 className={`font-righteous text-brandblue text-lg`}>Report duration</h3>

          <div className={`flex flex-row gap-2 items-end`}>
            <Number
              labelText='Report last:'
              placeholder="0"
              formFields={formFields}
              fieldName='reportDurationNumber'
              handleChange={handleChange}
              min={1}
              max={12}
              fullwidth={false}
            />
            <Button
              onClick={() => handleChange('reportDurationPeriod', 'weeks')}
              text='Weeks'
              variant={reportDurationPeriod === 'weeks' ? `primary` : `gray`}
              fullwidth={false}
            />
            <Button
              onClick={() => handleChange('reportDurationPeriod', 'months')}
              text='Months'
              variant={reportDurationPeriod === 'months' ? `primary` : `gray`}
              fullwidth={false}
            />
          </div>
        </div>


        {formErrors['reportDuration'] && <RedAlert size='small'>{formErrors['reportDuration']}</RedAlert>}
      </Card>}


      {organisationsToInclude && <Card fullwidth={true}>
        <div className={`flex flex-col gap-2`}>
          <h3 className={`font-righteous text-brandblue text-lg`}>Report frequency:</h3>
          <div className={`flex flex-row gap-2`}>
            <Button
              onClick={() => handleChangeFrequency('weekly')}
              text='Weekly'
              variant={reportingFrequency === 'weekly' ? `primary` : `gray`}
              fullwidth={false}
            />
            <Button
              onClick={() => handleChangeFrequency('monthly')}
              text='Monthly'
              variant={reportingFrequency === 'monthly' ? `primary` : `gray`}
              fullwidth={false}
            />
          </div>
        </div>

        {reportingFrequency === 'weekly' && <div className={`flex flex-row gap-2 flex-wrap`}>
          <p className={``}>Report until day:</p>
          <div className={`flex flex-row gap-1 flex-wrap`}>
            {days.map((day, index) => {
              return <Button
                key={index}
                onClick={() => handleChange('dayOfWeek', day)}
                text={day}
                variant={formFields && formFields['dayOfWeek'] === day ? `primary` : `gray`}
                fullwidth={false}
              />
            })}
          </div>
          <p className={`text=xs italic text-gray-700`}>Report will be generated and sent between 1-6am the next day.</p>
        </div>}


        {formErrors['Frequency'] && <RedAlert size='small'>{formErrors['Frequency']}</RedAlert>}
      </Card>}

      <Card fullwidth={true}>

        <h3 className={`font-righteous text-brandblue text-lg`}>Template Options</h3>

        <div className={`flex flex-row gap-2`}>

          <Button
            onClick={() => handleChangeTemplateOption('templateOption', 'default')}
            text='Use default formatting'
            variant={templateOption === 'default' ? `primary` : `gray`}
            fullwidth={false}
          />
          <Button
            onClick={() => handleChangeTemplateOption('templateOption', 'custom')}
            text='Use uploaded file as template'
            variant={templateOption === 'custom' ? `primary` : `gray`}
            fullwidth={false}
          />
        </div>


        {formErrors['templateOption'] && <RedAlert size='small'>{formErrors['templateOption']}</RedAlert>}



        {templateOption === 'custom' && <p>Upload a custom report template file in .xlsx format to use as the basis for the report. </p>}


        {templateOption === 'custom' && formFields['templateFileName'] &&
          <div className={`flex flex-row gap-2 items-center`}>
            <p className={``}> ✅ File uploaded. </p>
            {!showUploadButton && <Button
              onClick={() => setShowUploadButton(true)}
              text={`Edit`}
              fullwidth={false}
            />}
          </div>}



        {(showUploadButton || !formFields['templateFileName']) && templateOption === 'custom' &&
          <div className={`bg-gray-200 rounded px-2 py-2 flex flex-col gap-2 mt-2`}>
            <div className={`w-full flex flex-row gap-2 items-center justify-between`}>
              <input
                className={``}
                type='file'
                accept=".xls,.xlsx"
                name={`spreadsheetFile`}
                id={`spreadsheetFile`}
                onChange={(e) => setFileToUpload(e!.target!.files![0])}
              />

              {showUploadButton && <Button
                onClick={() => setShowUploadButton(false)}
                text={`Cancel`}
                variant={`gray`}
                fullwidth={false}
              />}
            </div>

            {formErrors['templateFile'] && <RedAlert size='small'>{formErrors['templateFile']}</RedAlert>}

          </div>}

        {templateOption === 'custom' &&
          <div className={`flex flex-col gap-2 mt-2`}>
            Add results at cell (spreadsheet cell reference):
            <input type={"text"}
              className={`bg-gray-200 border border-gray-400 text-gray-900 rounded hover:opacity-90-lg focus:ring-blue-500 focus:border-blue-500 block text-sm px-3 py-2 w-32`}
              onChange={(e) => handleChange('templateCellReference', e.target.value)}
              value={templateCellReference}
            />

            {formErrors['templateCellReference'] && <RedAlert size='small'>{formErrors['templateCellReference']}</RedAlert>}

          </div>}



      </Card>

      {reportDurationPeriod && <Card fullwidth={true}>

        <h3 className={`font-righteous text-brandblue text-lg`}>Export reports:</h3>


        <div className={`flex flex-col gap-2`}>
          <p className={``}>File format:</p>
          <div className={`flex flex-row gap-2`}>
            <Button
              onClick={() => handleChange('preferredFileFormat', 'xlsx')}
              text='xlsx'
              variant={preferredFileFormat === 'xlsx' ? `primary` : `gray`}
              fullwidth={false}
            />
            <Button
              onClick={() => handleChange('preferredFileFormat', 'pdf')}
              text='pdf'
              variant={preferredFileFormat === 'pdf' ? `primary` : `gray`}
              fullwidth={false}
            />
          </div>
        </div>
        {formErrors['preferredFileFormat'] && <RedAlert size='small'>{formErrors['preferredFileFormat']}</RedAlert>}

        {documentLibraries && documentLibraries.length > 0 &&

          <div className={`flex flex-col gap-2`}>
            <div className={`flex flex-row gap-2 items-center`}>
              <EnabledDisabled
                handleChange={handleChangeExportLocation}
                enabled={formFields && formFields['sendReportToOneDrive'] ? true : false}
                fieldName={'sendReportToOneDrive'}
              />
              <p>Save reports to document library</p>
              {sendReportToOneDrive && <select
                className={`bg-gray-200 border border-gray-400 text-gray-900 rounded hover:opacity-90-lg focus:ring-blue-500 focus:border-blue-500 block text-sm px-3 py-2`}
                onChange={(e) => handleChangeDocumentLibrary(e.target.value)}
                value={
                  formFields
                    && formFields['sendReportToOneDrive']
                    && formFields['sendReportToOneDrive']['tenantId']
                    && formFields['sendReportToOneDrive']['driveId']
                    ? `T=${formFields['sendReportToOneDrive']['tenantId']}&D=${formFields['sendReportToOneDrive']['driveId']}`
                    : ''}
              >
                <option value={''}>Please select...</option>
                {documentLibraries.map((library: any, index: number) => {
                  return <option key={index}
                    value={`T=${library.tenantId}&D=${library.driveId}`}>[{library.type}] {library.name}</option>
                })}
              </select>
              }
            </div>
          </div>}
        <div className={`flex flex-col gap-2`}>

          {/* <div className={`flex flex-row gap-2 items-center`}>
            <EnabledDisabled
              handleChange={handleChangeExportLocation}
              enabled={formFields && formFields['sendReportToEmail'] ? true : false}
              fieldName={'sendReportToEmail'}
            />
            <p>Email the reports</p>
          </div> */}

          {tableData && tableData.PortalUsers ? <div className={`flex flex-col gap-2 mb-4`}>
            <ListEmailAddresses
              formFields={formFields}
              thisChecklist={null}
              formErrors={formErrors}
              setFormFields={setFormFields}
              keyname={'EmailRecipients'}
            />
          </div> :
            <RedAlert>No portal users found. Please add portal users to enable email reports.</RedAlert>}



        </div>

        {formErrors['ExportLocation'] && <RedAlert size='small'>{formErrors['ExportLocation']}</RedAlert>}
      </Card>}



      <Card>
        <div className={`flex flex-col gap-4`}>
          <div className={``}>
            <h3 className={`font-righteous text-brandblue text-lg`}>Email content</h3>
            <p>Customize the email content for the report.</p>
          </div>

          <div className={``}>
            <p className={`font-bold`}>Subject line:</p>
            <input
              className={`text-sm px-3 py-2 bg-white drop-shadow-lg border border-gray-300 text-gray-900 rounded hover:opacity-90-lg focus:ring-blue-500 focus:border-blue-500 block w-full`}
              type={`text`}
              value={formFields['emailSubject'] || ''}
              onChange={(e) => setFormFields({ ...formFields, emailSubject: e.target.value })}
            />
          </div>

          <div className={``}>
            <p className={`font-bold`}>Body text:</p>
            <p className={``}>Use HTML tags to mark up text</p>


            <HtmlEditor
              value={formFields['emailBody'] || ''}
              onChange={(value: string) => setFormFields({ ...formFields, emailBody: value })}
            />


          </div>


        </div>
      </Card>

      {/* {JSON.stringify(formFields, null, 2)} */}


      {
        formFields['OrganisationsToInclude'] &&
        formFields['OrganisationsToInclude'].length > 0 &&
        formFields['preferredFileFormat'] &&
        formFields['reportDurationPeriod'] &&
        formFields['reportDurationNumber'] &&
        <Card fullwidth={true}>
          <div className={`w-full flex flex-col gap-2`}>
            <h3 className={`font-righteous text-brandblue text-lg`}>Test report export</h3>
            <p>Email a report to ({userData.email})</p>
            <Button
              onClick={() => testReport()}
              text={`Email report`}
              disabled={userData && userData['cognito:username'] ? false : true}
              variant={userData && userData['cognito:username'] ? `primary` : `gray`}
            />
          </div>
        </Card>}




    </div>

    <FooterNavButtonFrame>
      <Button
        internalLinkUrl='/automatic-reports/'
        text={'Cancel'}
        variant={'gray'}
        fullwidth={true}
        size='big'
      />
      <Button
        onClick={saveData}
        text={'Save'}
        variant={'primary'}
        fullwidth={true}
        size='big'
      />
    </FooterNavButtonFrame>

  </div>
}
export default AutomaticReportsForm